export const ErrorMessage = ({
  name,
  message,
}: {
  name: string;
  message?: string;
}) => {
  return message ? (
    <p
      data-testid={`${name}-alert`}
      role="alert"
      className="!text-xs !text-secondary-100"
    >
      {message}
    </p>
  ) : null;
};
